// =============================================================================
// src/features/analytics/analytics-insights-markdown-inline.ts - Conversor
// INLINE do markdown das edicoes vivas dos Cards Taticos (banco -> HTML).
// BORDA DE CONFIANCA XSS unica do digest: o markdown vem do banco via GraphQL,
// entao TODO texto passa por escapeHtml ANTES de qualquer tag nossa — so
// <strong>/<em> gerados aqui entram no HTML final. Os campos *Html dos tipos
// so podem ser alimentados por este modulo (ou por conteudo versionado).
// =============================================================================

import { escapeHtml } from '../../app/dom';

/** Junta linhas hard-wrapped (~100 col no documento fonte) num paragrafo so. */
export function analyticsInsightJoinHardWrap(paragraphLines: readonly string[]): string {
  return paragraphLines.map((paragraphLine) => paragraphLine.trim()).join(' ').trim();
}

/** Converte texto markdown inline em HTML seguro: escape-first, depois
 * **negrito** -> <strong>, *italico* -> <em>, `codigo` -> texto puro. */
export function analyticsInsightInlineHtml(rawMarkdownText: string): string {
  return escapeHtml(rawMarkdownText)
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>')
    .replace(/`([^`]+)`/g, '$1');
}

/** Remove marcadores inline SEM escapar — para campos que o markup escapa
 * sozinho (titulos, celulas de cabecalho, rodape de 5 campos, atribuicao). */
export function analyticsInsightPlainText(rawMarkdownText: string): string {
  return rawMarkdownText
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/`([^`]+)`/g, '$1')
    .trim();
}
